import 'react-table/react-table.css';
import React from 'react';
import { I18n } from 'react-redux-i18n';

class DynamicHeadersTable extends React.Component {
  constructor(props) {
    super(props);

    const { rows } = this.props;

    this.state = {
      rows,
    };
  }

  setHeaders = async () => {
    const { rows } = this.state;

    this.props.setHeaders(rows);
  };

  addGridRow = () => {
    this.setState((state) => ({
      rows: [...state.rows, { type: 'Header', headerKey: '', headerValue: '' }],
    }));
  };

  updateGridRow = (index, field, value) => {
    this.setState((state) => {
      const updatedGrid = [...state.rows];
      updatedGrid[index][field] = value;

      return { rows: updatedGrid };
    });
  };

  removeGridRow = (index) => {
    this.setState((state) => {
      const updatedGrid = [...state.rows];
      updatedGrid.splice(index, 1);
      return { rows: updatedGrid };
    }, this.setHeaders);
  };

  render() {
    const { rows } = this.state;

    return (
      <div
        className="mb-1 mx-5 items-center"
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <table className="table-responsive mx-auto px-5">
          <thead width="100%">
            <tr>
              <th width="auto" className="px-4 py-2 text-center">
                {I18n.t('BEE55' /* Ações */)}
              </th>
              <th width="015%" className="px-5 py-2 text-center">
                {I18n.t('BEE200' /* Tipo */)}
              </th>
              <th width="015%" className="px-5 py-2 text-center">
                {I18n.t('BEE227' /* Chave */)}
              </th>
              <th width="100%" className="px-5 py-2 text-center">
                {I18n.t('BEE1115' /* Valor */)}
              </th>
            </tr>
          </thead>
          <tbody
            style={{
              maxHeight: '168px',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {rows
              && rows.length > 0
              && rows.map((row, i) => (
                <tr
                  key={i}
                  style={{
                    display: 'flex',
                    tableLayout: 'auto',
                    width: '100%',
                  }}
                >
                  <td className="px-2 py-1" width="auto">
                    <div>
                      <button
                        type="button"
                        onClick={() => this.removeGridRow(i)}
                        title="Remover linha"
                        className="btn btn-sm btn-square btn-light"
                        aria-label={`Remover linha ${i + 1}`}
                      >
                        <span>Remover</span>
                      </button>
                    </div>
                  </td>
                  <td className="px-2 py-1" width="21%">
                    <select
                      className="form-control"
                      value={rows[i].type || 'Header'}
                      onChange={(e) => {
                        this.updateGridRow(i, 'type', e.target.value);
                      }}
                    >
                      <option key="Header" value="Header">
                        {I18n.t('BEE4449' /* Header */)}
                      </option>
                      <option key="Body" value="Body">
                        {I18n.t('BEE4450' /* Body */)}
                      </option>
                    </select>
                  </td>
                  <td className="px-2 py-1" width="30%">
                    <input
                      className="form-control"
                      value={row.headerKey}
                      onChange={(e) => this.updateGridRow(i, 'headerKey', e.target.value)}
                      onBlur={this.setHeaders}
                      placeholder={I18n.t('BEE227' /* Chave */)}
                    />
                  </td>
                  <td className="px-2 py-1" width="100%">
                    <input
                      className="form-control"
                      value={row.headerValue}
                      onChange={(e) => this.updateGridRow(i, 'headerValue', e.target.value)}
                      onBlur={this.setHeaders}
                      placeholder={I18n.t('BEE1115' /* Valor */)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="1" className="px-2 py-2 text-center">
                <button
                  type="button"
                  onClick={() => this.addGridRow()}
                  className="btn btn-sm btn-square btn-primary"
                  aria-label="Adicionar linha"
                >
                  <span>Adicionar</span>
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}
export default DynamicHeadersTable;
